import { render, staticRenderFns } from "./QBCallsView.vue?vue&type=template&id=b586d1a8&"
import script from "./QBCallsView.vue?vue&type=script&lang=js&"
export * from "./QBCallsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports